module.exports = __webpack_public_path__ + "media/svg/anos_iniciais-49c54123.svg";